import React, { FC } from 'react';
import { Button, Col, Row, Typography } from 'components';
import { CopyIcon, DeleteIcon, EditIcon, ViewIcon, ViewInvisibleIcon } from 'components/common/icons';
import styles from './styles.module.scss';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { useOnlineShopCard } from 'feature/supplierTabs/priceList/onlineShop/onlineShopCard/useOnlineShopCard';
import { OnlineShopAddEditModal } from 'feature/supplierTabs/priceList/onlineShop/addEdit';
import { CopiedIcon } from 'components/common/icons/contactFieldManagerIcons/CopiedIcon';

const { Text } = Typography;

interface IShippingAddress {
  data: Record<string, any>;
  onDeleteModalOpen: (id: string) => void;
}

export const OnlineShopCard: FC<IShippingAddress> = React.memo((props) => {
  const { data, onDeleteModalOpen } = props;

  const { login, password, id, webSiteLink } = data;
  const { addModalState, onAddModalStateChange, onCopy, copyStatus, onPasswordModeChange, isPasswordMode } =
    useOnlineShopCard();
  return (
    <>
      <Row gutter={[0, 10]} className={styles.online_shop_card}>
        <Col span={24}>
          <Row justify={'space-between'} className={'gap-16'} wrap={false} align={'middle'}>
            <Col span={20}>
              <Button
                style={{ padding: 0 }}
                block
                size={'small'}
                type="link"
                href={webSiteLink?.startsWith('http') ? webSiteLink : `https://${webSiteLink}`}
                target="_blank"
              >
                <Typography.Paragraph className={styles.link} ellipsis={{ tooltip: true }} title={webSiteLink}>
                  {webSiteLink}
                </Typography.Paragraph>
              </Button>
            </Col>
            <Col>
              <Row wrap={false}>
                <Col>
                  <HasAccess role={PERMISSIONS.suppliers.online_shop.delete}>
                    <Button size={'small'} type={'text'} onClick={() => onDeleteModalOpen(id)} icon={<DeleteIcon />} />
                  </HasAccess>
                </Col>
                <Col>
                  <HasAccess role={PERMISSIONS.suppliers.online_shop.write}>
                    <Button size={'small'} type={'text'} onClick={onAddModalStateChange} icon={<EditIcon />} />
                  </HasAccess>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 4]}>
            <Col span={24}>
              <Row justify={'space-between'} align={'middle'}>
                <Col>
                  <Text type={'secondary'}>Login</Text>
                </Col>
                <Col>
                  <Row align={'middle'} className={'gap-4'}>
                    <Text type={'secondary'}>{login ? login : 'Not Set'}</Text>
                    {login && (
                      <Button
                        style={{ padding: 0, height: 16 }}
                        type={'link'}
                        onClick={() => onCopy(login)}
                        size={'small'}
                      >
                        {copyStatus[login] ? <CopiedIcon color={'#525866'} /> : <CopyIcon color={'#525866'} />}
                      </Button>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 4]}>
            <Col span={24}>
              <Row justify={'space-between'} align={'middle'}>
                <Col>
                  <Text type={'secondary'}>Password</Text>
                </Col>
                <Col>
                  <Row align={'middle'} className={'gap-4'}>
                    <Text type={'secondary'}>{password ? (isPasswordMode ? '*********' : password) : 'Not Set'}</Text>
                    {!isPasswordMode && password && (
                      <Button
                        style={{ padding: 0, height: 16 }}
                        type={'link'}
                        onClick={() => onCopy(password)}
                        size={'small'}
                      >
                        {copyStatus[password] ? <CopiedIcon color={'#525866'} /> : <CopyIcon color={'#525866'} />}
                      </Button>
                    )}
                    {password && (
                      <Button
                        style={{ padding: 0, height: 16 }}
                        type={'link'}
                        onClick={onPasswordModeChange}
                        size={'small'}
                      >
                        {isPasswordMode ? <ViewIcon /> : <ViewInvisibleIcon />}
                      </Button>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <OnlineShopAddEditModal onModalStateChange={onAddModalStateChange} modalState={addModalState} dataToEdit={data} />
    </>
  );
});
